import { onWordTemplateForListViewActivity } from "common/signalR";
import ActivityPanel from "components/ActivityPanel/ActivityPanel";
import React from "react";
import { WordTemplateForListViewActivityCard } from "./WordTemplateForListViewActivityCard";
import { useCurrentUser } from "common/SessionContext";

interface Props {
  wordTemplateForListViewId: number
  fileId: string
  config: server.dto.ActivityPanelConfig
}

export const WordTemplateForListViewActivityPanel = (props: Props) => {
  const currentUser = useCurrentUser();
  const [fileId, setFileId] = React.useState<string>(props.fileId);

  return <ActivityPanel<server.dto.WordTemplateForListViewActivity>
    activityKey="wordTemplateForListView"
    itemId={props.wordTemplateForListViewId}
    config={props.config}
    fetchActivities={(page, perPage) => window.CoreApi.WordTemplateForListView.ListActivity({ itemId: props.wordTemplateForListViewId, page, perPage })}
    renderActivity={(activity => <WordTemplateForListViewActivityCard
      currentFileId={fileId}
      setCurrentFileId={setFileId}
      key={activity.activityId}
      activity={activity}
    />)}
    onActivityRegisterFn={onWordTemplateForListViewActivity}
    onActivity={(activity) => {
      if (activity.action.value === "uploadedNewFile") {
        setFileId(activity.fileId);
      }

      const iAmActor = (activity.actor?.userId === currentUser.userId);

      return { refreshActivities: iAmActor };
    }}
  />
}
